import { getRoomByIndex } from "./roomsRendered";
export function highlightActiveRoomsOnMap(activeIndex) {
    const activeRoom = getRoomByIndex(activeIndex);
    const roomId = activeRoom.dataset.id;
    if (roomId) {
        const rooms = document.querySelectorAll(`.building-map .${roomId}`);
        activeRoom.classList.add("active");
        for (let i = 0, l = rooms.length; i < l; i++) {
            rooms[i].classList.add("active");
        }
    }
}
